/**
 * HouseStructureFilter
 *
 * 주택 구조 필터 (계단식/복도식 + 방개수 + 화장실개수)
 * 예: 계단식 + 방3 + 화장실2 = "계32"
 */
class HouseStructureFilter {
  constructor() {
    this.model = null; // { type: '계', rooms: 3, bathrooms: 2 } => "계32"
    this.eGui = null;
    this.params = null;
  }

  init(params) {
    this.params = params;
    this.eGui = document.createElement('div');
    this.eGui.className = 'aptrank-custom-filter';
    this.eGui.style.cssText = `
      background: white;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 20px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
      width: 320px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    `;

    this.render();
  }

  getGui() {
    return this.eGui;
  }

  render() {
    const currentType = this.model?.type || '';
    const currentRooms = this.model?.rooms || '';
    const currentBathrooms = this.model?.bathrooms || '';

    this.eGui.innerHTML = `
      <div style="margin-bottom: 16px;">
        <label style="display: block; margin-bottom: 8px; font-weight: 600; color: #333;">구조 유형</label>
        <div style="display: flex; gap: 8px;">
          <button
            class="structure-type-btn"
            data-type="계"
            style="
              flex: 1;
              padding: 8px 12px;
              border: 1px solid ${currentType === '계' ? '#1976d2' : '#ddd'};
              background: ${currentType === '계' ? '#e3f2fd' : 'white'};
              color: ${currentType === '계' ? '#1976d2' : '#666'};
              border-radius: 4px;
              cursor: pointer;
              font-weight: ${currentType === '계' ? '600' : '400'};
            "
          >
            계단식
          </button>
          <button
            class="structure-type-btn"
            data-type="복"
            style="
              flex: 1;
              padding: 8px 12px;
              border: 1px solid ${currentType === '복' ? '#1976d2' : '#ddd'};
              background: ${currentType === '복' ? '#e3f2fd' : 'white'};
              color: ${currentType === '복' ? '#1976d2' : '#666'};
              border-radius: 4px;
              cursor: pointer;
              font-weight: ${currentType === '복' ? '600' : '400'};
            "
          >
            복도식
          </button>
        </div>
      </div>

      <div style="margin-bottom: 16px;">
        <label style="display: block; margin-bottom: 8px; font-weight: 600; color: #333;">방 개수</label>
        <input
          type="number"
          class="rooms-input"
          value="${currentRooms}"
          min="0"
          max="9"
          placeholder="방 개수"
          style="
            width: 100%;
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            box-sizing: border-box;
          "
        />
      </div>

      <div style="margin-bottom: 20px;">
        <label style="display: block; margin-bottom: 8px; font-weight: 600; color: #333;">화장실 개수</label>
        <input
          type="number"
          class="bathrooms-input"
          value="${currentBathrooms}"
          min="0"
          max="9"
          placeholder="화장실 개수"
          style="
            width: 100%;
            padding: 8px 12px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            box-sizing: border-box;
          "
        />
      </div>

      <div style="display: flex; gap: 8px; margin-top: 16px;">
        <button
          class="reset-btn"
          style="
            flex: 1;
            padding: 8px 16px;
            border: 1px solid #ddd;
            background: white;
            color: #666;
            border-radius: 4px;
            cursor: pointer;
            font-weight: 500;
          "
        >
          초기화
        </button>
        <button
          class="apply-btn"
          style="
            flex: 1;
            padding: 8px 16px;
            border: none;
            background: #1976d2;
            color: white;
            border-radius: 4px;
            cursor: pointer;
            font-weight: 500;
          "
        >
          적용
        </button>
      </div>
    `;

    this.attachEventListeners();
  }

  attachEventListeners() {
    // 구조 유형 버튼
    const typeButtons = this.eGui.querySelectorAll('.structure-type-btn');
    typeButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        const type = btn.getAttribute('data-type');
        if (!this.model) {
          this.model = { type: '', rooms: '', bathrooms: '' };
        }
        this.model.type = this.model.type === type ? '' : type;
        this.render();
      });
    });

    // 방 개수 입력
    const roomsInput = this.eGui.querySelector('.rooms-input');
    roomsInput.addEventListener('input', (e) => {
      if (!this.model) {
        this.model = { type: '', rooms: '', bathrooms: '' };
      }
      const value = e.target.value;
      this.model.rooms = value ? Number(value) : '';
    });

    // 화장실 개수 입력
    const bathroomsInput = this.eGui.querySelector('.bathrooms-input');
    bathroomsInput.addEventListener('input', (e) => {
      if (!this.model) {
        this.model = { type: '', rooms: '', bathrooms: '' };
      }
      const value = e.target.value;
      this.model.bathrooms = value ? Number(value) : '';
    });

    // 초기화 버튼
    const resetBtn = this.eGui.querySelector('.reset-btn');
    resetBtn.addEventListener('click', () => {
      this.model = null;
      this.render();
      this.params.filterChangedCallback();
    });

    // 적용 버튼
    const applyBtn = this.eGui.querySelector('.apply-btn');
    applyBtn.addEventListener('click', () => {
      this.params.filterChangedCallback();
    });
  }

  getModel() {
    if (!this.model) return null;

    const { type, rooms, bathrooms } = this.model;

    // 모두 비어있으면 null
    if (!type && rooms === '' && bathrooms === '') {
      return null;
    }

    // type이 있고, rooms와 bathrooms 중 하나라도 있으면 구조 문자열 생성
    if (type && (rooms !== '' || bathrooms !== '')) {
      const roomsStr = rooms !== '' ? String(rooms) : '';
      const bathroomsStr = bathrooms !== '' ? String(bathrooms) : '';
      const structure = `${type}${roomsStr}${bathroomsStr}`;
      return { structure };
    }

    return null;
  }

  setModel(model) {
    if (!model) {
      this.model = null;
      this.render();
      return;
    }

    // model.structure 형식: "계32" => { type: '계', rooms: 3, bathrooms: 2 }
    if (model.structure) {
      const structure = String(model.structure);
      if (structure.length >= 1) {
        const type = structure[0]; // '계' 또는 '복'
        const rooms = structure.length >= 2 ? Number(structure[1]) : '';
        const bathrooms = structure.length >= 3 ? Number(structure[2]) : '';

        this.model = { type, rooms, bathrooms };
        this.render();
      }
    }
  }

  isFilterActive() {
    return this.model !== null;
  }

  doesFilterPass(params) {
    // AG-Grid에서 사용하지 않음 (서버 필터링)
    return true;
  }
}

export default HouseStructureFilter;
